import styled from "@emotion/styled";
import { Button, Form, Input, message, Modal } from "antd";
import React, { useEffect } from "react";
import { useChangePasswordUserSystem } from "hooks/useAuth";
import { UserSystemData } from "services/interface";

interface ModalChangePasswordProps {
  editData: UserSystemData | undefined;
  isShow: boolean;
  onClose: () => void;
}

const ModalChangePassword = ({ editData, isShow, onClose }: ModalChangePasswordProps) => {
  const { mutate, isPending } = useChangePasswordUserSystem();
  const [form] = Form.useForm();

  useEffect(() => {
    if (isShow) {
      form.resetFields();
    }
  }, [isShow, form]);

  const onFinish = (values: { password: string }) => {
    const email = editData?.email?.trim();
    if (!editData?.user_id || !email) {
      message.warning("ไม่พบอีเมลผู้ใช้งาน จึงไม่สามารถเปลี่ยนรหัสผ่านได้");
      return;
    }

    mutate(
      {
        id: editData.user_id,
        username: email,
        password: values.password,
      },
      {
        onSuccess: (data) => {
          if (!data?.error_message && data?.status === "success") {
            message.success("เปลี่ยนรหัสผ่านสำเร็จ");
            onClose();
          } else {
            message.error(`เปลี่ยนรหัสผ่านไม่สำเร็จ: ${data?.error_message || "เกิดข้อผิดพลาด"}`);
          }
        },
        onError: () => {
          message.error("เปลี่ยนรหัสผ่านไม่สำเร็จ: เกิดข้อผิดพลาด");
        },
      }
    );
  };

  return (
    <Modal
      title="เปลี่ยนรหัสผ่าน"
      open={isShow}
      maskClosable={false}
      onCancel={() => onClose()}
      footer={null}
    >
      <WrapperAll>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="รหัสผ่านใหม่"
            name="password"
            rules={[
              { required: true, message: "กรุณากรอกรหัสผ่านใหม่" },
              { min: 6, message: "รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร" },
            ]}
          >
            <Input.Password placeholder="กรอกรหัสผ่านใหม่" disabled={isPending} />
          </Form.Item>

          <Button type="primary" htmlType="submit" loading={isPending} disabled={isPending}>
            บันทึก
          </Button>
        </Form>
      </WrapperAll>
    </Modal>
  );
};

export default ModalChangePassword;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
`;
